module.exports = __webpack_public_path__ + "img/coin-3.9fe1e255.png";